<template>
  <div v-if="isEditing">
    <el-form-item prop="title" label="题目">
      <wjQuillEditor :content="tempQuesData.title" :config="config" @onChange="handleEditorChange"></wjQuillEditor>
    </el-form-item>
    <el-form-item label="备注">
      <el-input class="editor-input" v-model="tempQuesData.description"></el-input>
    </el-form-item>
    <div class="edit-settings">
      <el-form-item label="打分类型">
        <el-select class="maxSelectInput" v-model="tempQuesData.starType">
          <el-option label="满意度" :value="0"></el-option>
          <el-option label="认同度" :value="1"></el-option>
          <el-option label="重要度" :value="2"></el-option>
          <el-option label="愿意度" :value="3"></el-option>
          <el-option label="符合度" :value="4"></el-option>
          <el-option label="自定义" :value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="customInput" v-if="tempQuesData.starType == 5">
        <el-input type="text" v-model="tempQuesData.starShowCustomStart"></el-input>-
        <el-input type="text" v-model="tempQuesData.starShowCustomEnd"></el-input>
      </el-form-item>
      <el-form-item label="打分范围">
        <el-input-number class="starRangeInput" v-model="tempQuesData.starNum" :min="1" :max="11"></el-input-number>
      </el-form-item>
      <el-form-item label="起始数值">
        <el-input-number
          class="starRangeInput"
          v-model="tempQuesData.starBeginNum"
          :min="0"
          :max="10"
        ></el-input-number>
        <el-checkbox v-model="tempQuesData.revertSort">反转</el-checkbox>
      </el-form-item>
    </div>
  </div>
  <div v-else>
    <div class="ques-title">
      {{ ques.index + 1 }}.
      <p style="display: inline-block;" v-html="ques.title"></p>
      <i v-if="ques.required" class="required-icon">*</i>
      <span class="gotoDisp" v-if="starEntityList">{{ showLogic() }}</span>
    </div>
    <p class="ques-desc">{{ ques.description }}</p>
    <div class="starRadios" v-if="!ques.revertSort">
      <span
        class="starText"
      >{{ ques.starType !== 5 ? '非常不' + starMap[ques.starType] : ques.starShowCustomStart }}</span>
      <el-radio
        @change="handleCheckStar(ques)"
        v-model="ques.checkedStar"
        class="starRadio"
        :key="i"
        :label="ques.starBeginNum + i - 1"
        v-for="i in ques.starNum"
      >{{ +ques.starBeginNum + i - 1 }}</el-radio>
      <span
        class="starText"
      >{{ ques.starType !== 5 ? '非常' + starMap[ques.starType] : ques.starShowCustomEnd }}</span>
    </div>
    <div class="starRadios" v-else>
      <span
        class="starText"
      >{{ ques.starType !== 5 ? '非常' + starMap[ques.starType] : ques.starShowCustomEnd }}</span>
      <el-radio
        @change="handleCheckStar(ques)"
        v-model="ques.checkedStar"
        class="starRadio"
        :key="i"
        :label="ques.starBeginNum + ques.starNum - i"
        v-for="i in +ques.starNum"
      >{{ +ques.starBeginNum + ques.starNum - i }}</el-radio>
      <span
        class="starText"
      >{{ ques.starType !== 5 ? '非常不' + starMap[ques.starType] : ques.starShowCustomStart }}</span>
    </div>
  </div>
</template>
<script>
import wjQuillEditor from "./wj-quill-editor.vue";
export default {
  name: "textArea",
  data() {
    return {
      starMap: ["满意", "认同", "重要", "愿意", "符合"]
    };
  },
  props: ["tempQuesData", "isEditing", "ques", "config", "starEntityList"],
  components: {
    wjQuillEditor
  },
  methods: {
    handleEditorChange(data) {
      this.tempQuesData.title = data;
    },
    showLogic() {
      let gotoMsg = "";
      this.starEntityList.forEach(item => {
        if (item.start != item.end) {
          gotoMsg += `选择${item.start}分至${item.end}分则跳转至第${+item.goto +
            1}题; `;
        } else {
          gotoMsg += `选择${item.start}分则跳转至第${+item.goto + 1}题; `;
        }
      });
      return gotoMsg;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/star.vue